import React, { Component } from 'react'
import $ from 'jquery';

import { partnerImgs } from './config';

/* eslint-disable*/

class PartnerSlider extends Component {
  componentDidMount(){
    $(document).ready(function ($) {
      var options = {
          $AutoPlay: true,
                $AutoPlaySteps: 1,               
                $AutoPlayInterval: 5000,
                $PauseOnHover: 1,
                $ArrowKeyNavigation: true,
                $SlideDuration: 1000,
                $SlideSpacing: 10,
                $MinDragOffsetToSlide: 20,
                $SlideWidth: 290,
                $DisplayPieces: 5,
                $ParkingPosition: 0,
                $UISearchMode: 1,
                $PlayOrientation: 1,                                
                $DragOrientation: 1,
                $FillMode: 5
        };

      var jssor_slider1 = new $JssorSlider$('slider_carousel', options);
      function ScaleSlider() {
        var parentWidth = jssor_slider1.$Elmt.parentNode.clientWidth;
        if (parentWidth) {
            jssor_slider1.$ScaleWidth(parentWidth - 30);
        }
        else
            window.setTimeout(ScaleSlider, 30);
    }
    ScaleSlider();

    $(window).bind("load", ScaleSlider);
    $(window).bind("resize", ScaleSlider);
    $(window).bind("orientationchange", ScaleSlider);
  });
  }
  render() {
    return (
      <div id="partners">
      <div id="slider_carousel" jssor-slider="true" style={{'position': 'relative', 'top': '0px', 'left': '0px', 'width': '1500px', 'height': '100%'}}>
        <div data-u="slides" style={{'position': 'absolute', 'left': '0px', 'top': '0px', 'width': '1500px', 'height': '100%','overflow': 'hidden'}}>
          {partnerImgs.map((partner) => {
            return (
                <div>
                  <a rel="noopener noreferrer" target="_blank" href={partner.href}>
                    <img data-u="image" src={partner.src} alt={partner.name} />
                  </a>
                </div>
            );
          })}
        </div>
     </div>
    </div>
    );
  }
}


export default PartnerSlider;



// WEBPACK FOOTER //
// ./src/components/partner-slider/PartnerSlider.js